<template>
  <div>
    <h2>{{ obj.name }}</h2>
    <p v-show="obj.typeName == null ? false : true">类别: {{ obj.typeName }}</p>
    <p v-show="obj.createBy == null ? false : true">作者: {{ obj.createBy }}</p>
    <p v-show="obj.labelName == null ? false : true">
      标签: {{ obj.labelName }}
    </p>
    <img
      :src="obj.imgUrl"
      alt=""
      v-show="obj.imgUrl == null ? false : true"
      class="img1"
    />
    <p v-html="obj.content" class="text">{{ obj.content }}</p>
    <div>
      <Button type="primary" @click="btn(obj.id)" class="bian"
        >编辑</Button
      >
      <Space wrap>
        <Poptip
          confirm
          title="确定要删除这条数据吗?"
          @on-ok="ok"
        >
          <Button type="info">删除</Button>
        </Poptip>
      </Space>
    </div>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>

<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  props: {
    workId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      obj: {},
      query: Number(""),
    };
  },
  created() {
    this.query = this.$route.query.id;
    this.search();
  },
  methods: {
    search() {
      let q = {};
      $utils.api.load("/admin/system/knowledge/list", q).then((res) => {
        if (res && res.rows) {
          let arr = res.rows;
          // console.log(arr, "-----------------");
          for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            if (item.id == this.query) {
              this.obj = item;
            }
          }
        }
      });
    },
    btn(row) {
      $utils.url.push({
        name: "knowledgeBase_edit",
        query: { knowledgeId: row , action:"edit" },
      });
    },
    // /admin/system/knowledge/{Long[]},"delete"
    async ok() {
      console.log(5555555,this.query);
      let q = {
        id:this.query
      }
      let res = await $utils.api.load("/admin/system/knowledge/remove",q,"post")  //就只传了一个id
          if (res) {
            // console.log(res, "-----------------");
            this.$router.go(-1);
          }
          
    },
  },
};
</script>

<style lang="less" scoped>
h2 {
  color: black;
}
.text {
  color: rgb(36, 35, 35);
  font-size: 14px;
}
.img1 {
  width: 50%;
}
.bian{
  margin-right: 10px;
}
</style>
